<template>
  <v-app id="pole">
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-select
        class="ma-2 mt-6"
        label="Оберіть область"
        :items="regions"
        v-model="region"
        solo
      ></v-select>

      <v-select
        class="mt-0 ma-2"
        label="Оберіть район"
        v-if="region"
        :items="districts"
        v-model="district"
        v-on:change="districtChanged"
        solo
      ></v-select>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>#Вашеполе</v-toolbar-title>
      <v-spacer></v-spacer>
       <div class="flex-grow-1">{{this.headerLocationTitle}}</div>
      <v-toolbar-items>
        <v-btn 
          v-for="link in links"
          :key="link.tiitle"
          :to="link.url"
          text
        >
          {{link.title}}
        </v-btn>

      </v-toolbar-items>
    </v-app-bar>
    
    <v-snackbar 
      :top="true"
      :color="'info'"
      :timeout="this.$store.state.snackbar.timeout"
      v-model="this.$store.state.snackbar.status"
    >
      {{this.$store.state.snackbar.text}}
      <v-btn
        color="white"
        text
        @click="() => { this.$store.commit('hideAlert')}"
      >
        Закрити
      </v-btn>
    </v-snackbar>

    <v-content>
      <router-view></router-view>
    </v-content>
    
      <!-- SPINNER -->
      <v-card
        v-if="this.$store.state.loading"
        max-width="344"
        class="mx-auto loading"
      >
        <v-progress-circular    
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <p>Завантаження даних ...</p>
      </v-card>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer: null,
      links: [
        {title: 'Карта', url: '/map'},
        {title: 'Статистика', url: '/statistics'}
      ],
      region: null,
      district: null,
      headerLocationTitle: '',
    }),
    computed: {
        regions() {
          return Object.keys(this.$store.state.locations)
        },
        districts() {
          let districts = this.$store.state.locations[this.region];
          return Object.keys(districts).map(function(k){
            return {value: k, text: districts[k]};
          })
        }
    },
    methods: {
      districtChanged() {
        this.$store.commit('setCurrentRegion', this.region)
        this.$store.commit('setCurrentDistrict', this.district)
        this.drawer = false

        this.headerLocationTitle = this.region + ' / ' + this.$store.getters.getCurrentDistrictCaption
      }
    },
    created() {
        this.$http.get('locations')
          .then(response => {
              return response.json()
          })
          .then(locations => {
              this.$store.commit('setLocations', locations)
          })
    }
  }
</script>

<style>
.v-card.loading {
  width: 292px;
  height: 140px;
  text-align: center;
  padding: 28px 0;

    left: 0;
    top: 40%;
    right: 0;
    position: absolute;
    margin: auto;
    z-index: 999;
}
.v-card.loading p {
  margin-top: 18px;
  color: #3a3a3a;
  font-family: Roboto, sans-serif;
}
.v-progress-circular {
  color: #0aabff;
}
</style>